<section class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-lg-6">
        <span class="cat__core__title">
          <strong>Trial Users List</strong>
        </span>
      </div>
      <div class="col-lg-6 text-right">
        <button type="button" class="btn btn-success btn-sm mr-2" (click)="exportToExcel()">
          <i class="fa fa-file-excel-o mr-1"></i>Export to Excel
        </button>
        <button type="button" class="btn btn-danger btn-sm mr-2" (click)="exportToPDF()">
          <i class="fa fa-file-pdf-o mr-1"></i>Export to PDF
        </button>
        <button type="button" class="btn btn-primary btn-sm mr-2" (click)="refreshUsersList()">
          <i class="fa fa-refresh mr-1"></i>Refresh
        </button>
        <button type="button" class="btn btn-info btn-sm" (click)="navigateToLogin()">
          <i class="fa fa-sign-in mr-1"></i>Go to Login
        </button>
      </div>
    </div>
  </div>

  <div class="card-block">
    <!-- Loading Indicator -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="mt-3">Loading trial users...</p>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage && !isLoading" class="alert alert-danger alert-dismissible fade show" role="alert">
      <i class="fa fa-exclamation-triangle mr-2"></i>
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <!-- Users Table -->
    <div *ngIf="!isLoading && !errorMessage" class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table 
            datatable 
            [dtOptions]="dtOptions" 
            [dtTrigger]="dtTrigger"
            class="table table-hover table-striped table-bordered compact cell-border nowrap"
            style="width: 100%">
            <thead>
              <tr>
                <th style="width: 5%; text-align: center;">Sr. No.</th>
                <th style="width: 10%;">First Name</th>
                <th style="width: 10%;">Last Name</th>
                <th style="width: 15%;">Email</th>
                <th style="width: 10%;">Phone</th>
                <th style="width: 15%;">Company Details</th>
                <th style="width: 8%;">Status</th>
                <th style="width: 12%;">Source</th>
                <th style="width: 10%;">Created At</th>
                <th style="width: 5%; text-align: center;">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of trialUsersList; let i = index">
                <td style="text-align: center;">{{ i + 1 }}</td>
                <td>{{ user.first_name || 'N/A' }}</td>
                <td>{{ user.last_name || 'N/A' }}</td>
                <td>{{ user.email || 'N/A' }}</td>
                <td>{{ user.phone || 'N/A' }}</td>
                <td>{{ user.company_details || 'N/A' }}</td>
                <td>
                  <span class="badge" 
                        [ngClass]="{
                          'badge-warning': user.status === 'Pending',
                          'badge-success': user.status === 'Activated',
                          'badge-danger': user.status === 'Completed',
                          'badge-secondary': !user.status
                        }">
                    {{ user.status || 'N/A' }}
                  </span>
                </td>
                <td>{{ user.source || 'N/A' }}</td>
                <td>{{ user.created_at | date: 'dd-MMM-yyyy HH:mm' }}</td>
                <td style="text-align: center;">
                  <button 
                    type="button" 
                    class="btn btn-sm btn-primary mr-1" 
                    (click)="openEditModal(user)"
                    title="Edit User">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button 
                    type="button" 
                    class="btn btn-sm btn-danger" 
                    (click)="confirmDelete(user)"
                    title="Delete User">
                    <i class="fa fa-trash-o"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty State -->
        <div *ngIf="trialUsersList.length === 0 && !isLoading && !errorMessage" class="text-center py-5">
          <i class="fa fa-users fa-3x text-muted mb-3"></i>
          <h4 class="text-muted">No Trial Users Found</h4>
          <p class="text-muted">No trial users have been created yet.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<app-alert></app-alert>

<!-- Extend Trial Period Modal -->
<div class="modal fade" id="editUserModal" tabindex="-1" role="dialog" aria-labelledby="editUserModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editUserModalLabel">
          <i class="fa fa-clock-o mr-2"></i>Extend Trial Period
        </h5>
        <button type="button" class="close" (click)="cancelEdit()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <div class="modal-body">
        <!-- User Info Display -->
        <div class="alert alert-info mb-3" *ngIf="editingUser">
          <strong><i class="fa fa-user mr-1"></i>User:</strong> {{ editingUser.first_name }} {{ editingUser.last_name }}<br>
          <strong><i class="fa fa-envelope mr-1"></i>Email:</strong> {{ editingUser.email }}
        </div>

        <!-- Current Extended Days Info -->
        <div class="alert alert-secondary mb-3">
          <strong><i class="fa fa-calendar mr-1"></i>Current Trial Days:</strong> 
          <span class="badge badge-primary ml-2" style="font-size: 1rem;">{{ originalExtendedDays }} days</span>
        </div>

        <form>
          <!-- Is Extended Radio Buttons -->
          <div class="form-group">
            <label class="d-block font-weight-bold">Extend Trial Period? <span class="text-danger">*</span></label>
            <div class="custom-control custom-radio custom-control-inline">
              <input 
                type="radio" 
                id="extendYes" 
                name="IsExtended" 
                class="custom-control-input" 
                [(ngModel)]="extendTrialForm.IsExtended"
                value="yes">
              <label class="custom-control-label" for="extendYes">
                <i class="fa fa-check-circle text-success mr-1"></i>Yes
              </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input 
                type="radio" 
                id="extendNo" 
                name="IsExtended" 
                class="custom-control-input" 
                [(ngModel)]="extendTrialForm.IsExtended"
                value="no">
              <label class="custom-control-label" for="extendNo">
                <i class="fa fa-times-circle text-danger mr-1"></i>No
              </label>
            </div>
          </div>

          <!-- Additional Days Input (shown only when Yes is selected) -->
          <div class="form-group" *ngIf="extendTrialForm.IsExtended === 'yes'">
            <label for="additionalDays" class="font-weight-bold">
              Add Days to Trial <span class="text-danger">*</span>
            </label>
            <input 
              type="number" 
              class="form-control form-control-lg" 
              id="additionalDays" 
              [(ngModel)]="extendTrialForm.additionalDays"
              name="additionalDays"
              min="1"
              placeholder="Enter number of days to add"
              required>
            <small class="form-text text-muted">
              <i class="fa fa-info-circle mr-1"></i>
              Days will be added to current total. 
              New total: <strong>{{ originalExtendedDays + (extendTrialForm.additionalDays || 0) }} days</strong>
            </small>
          </div>

          <!-- Calculation Display -->
          <div class="alert alert-success" *ngIf="extendTrialForm.IsExtended === 'yes' && extendTrialForm.additionalDays > 0">
            <h6 class="mb-2"><i class="fa fa-calculator mr-1"></i>Summary:</h6>
            <div class="calculation-display">
              <div class="d-flex justify-content-between">
                <span>Current Days:</span>
                <strong>{{ originalExtendedDays }}</strong>
              </div>
              <div class="d-flex justify-content-between">
                <span>Additional Days:</span>
                <strong>+ {{ extendTrialForm.additionalDays }}</strong>
              </div>
              <hr class="my-2">
              <div class="d-flex justify-content-between">
                <span class="text-success"><strong>New Total:</strong></span>
                <strong class="text-success" style="font-size: 1.2rem;">{{ originalExtendedDays + extendTrialForm.additionalDays }} days</strong>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancelEdit()">
          <i class="fa fa-times mr-1"></i>Cancel
        </button>
        <button 
          type="button" 
          class="btn btn-primary" 
          (click)="updateTrialUser()"
          [disabled]="isLoading">
          <i class="fa fa-save mr-1"></i>
          <span *ngIf="!isLoading">Update Trial Period</span>
          <span *ngIf="isLoading">Updating...</span>
        </button>
      </div>
    </div>
  </div>
</div>

